import React from "react";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, Layers, Restaurant } from "@mui/icons-material";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import EditPricePlan from "../../licensing/Views/PricePlans/EditPricePlan";
import PricePlan from "../../licensing/Models/PricePlan";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { JamezzTableLinkToRelation } from "../../components/JamezzTable/JamezzTableFields";
import Button from "../../components/CustomButtons/Button";
import { useNavigate } from "react-router";
import { useDialog } from "../Upsell/modernTS/JUI/Dialogs";

function SubsPricePlansIndex({ classes }) {
  const navigate = useNavigate();
  // TODO: Laura - move dialog container to app root
  const { openDialog } = useDialog();

  const openNewPricePlanDialog = async (row) => {
    const model = !row
      ? new PricePlan()
      : await PricePlan.get(row[0]).then(({ model }) => {
          model.id = null;
          return model;
        });

    openDialog({
      children: (
        <EditPricePlan
          onSave={(s) => {
            return new Promise((resolve) => {
              s.apiCreate().then(({ model }) => {
                resolve();
                let url = "/manager/subspriceplans/" + model.id + "/edit";
                navigate(url);
              });
            });
          }}
          pricePlan={model}
        />
      ),
    });
  };

  const actions = [
    {
      icon: Layers,
      tooltip: getTranslation("Duplicate"),
      action: openNewPricePlanDialog,
    },
  ];
  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tKey={"All Price Plans"} />} />

      <GridContainer>
        <GridItem xs={12}>
          <Button className={classes.marginRight} color={"success"} onClick={() => openNewPricePlanDialog()}>
            <Add className={classes.icons} /> <TranslationWrapper tKey={"New price plan"} />
          </Button>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12}>
          <JamezzTable
            actions={actions}
            dataMapping={[
              { dbfield: "id", editable: false },
              {
                dbfield: "name",
                editable: false,
              },
              { dbfield: "description", editable: false },
              {
                customData: (a) => a,
                customRender: (entry) => {
                  return entry.subs_debtor_id > 0 ? "Commission Price Plan" : "Price Plan";
                },
              },
              new JamezzTableLinkToRelation("subs_debtor.company_name", "subsdebtors/:id/edit", {
                id: "subs_debtor_id",
              }),
              { dbfield: "subs_debtor_id", hide: true },
            ]}
            dbfields={"id,name,description,subs_debtor_id,subs_debtor.id,subs_debtor.company_name"}
            delete={false}
            editLink={"./:id/edit"}
            editLinkPermission={"subspriceplans/:id/edit"}
            fetchUrl={"core/subsPricePlan"}
            filters={{}}
            headerIcon={<Restaurant />}
            headers={[
              {
                label: "#",
                sortable: true,
                sortKey: "id",
              },
              {
                label: getTranslation("Name"),
                sortable: true,
                sortKey: "name",
              },
              {
                label: getTranslation("Description"),
                sortable: true,
                sortKey: "description",
              },
              {
                label: getTranslation("Type"),
                sortable: false,
              },
              {
                label: getTranslation("Commission Debtor"),
                sortable: false,
              },
            ]}
            reduxKey={"subs_price_plan"}
            tableTitle={<TranslationWrapper tKey={"Price Plans"} />}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(SubsPricePlansIndex, vestigingStyle);
